import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import ClientInviteActivationPage from "@/pages/client/ClientInviteActivationPage";

export const Route = createFileRoute("/client_/invite/activate")({
  head: () => pageHead("Activate Your Client Portal Account", "Securely activate your AKIVA Client Portal invitation.", "/client/invite/activate", true),
  component: ClientInviteActivationPage,
});
